import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import RoundContainer from '../RoundContainer/RoundContainer';
import { useClipboard } from 'shared/libs/hooks';

type CopyIconProps = {
  value: string;
  size?: number;
  containerSize?: number;
  className?: string;
  id?: string;
};

const CopyIcon: React.FC<CopyIconProps> = ({
  value,
  size = 20,
  containerSize = 32,
  className,
  id
}) => {
  const { copyToClipboard, isCopied } = useClipboard();

  const handleCopy = () => {
    copyToClipboard(value);
  };

  const icon = (
    <div style={{ position: 'relative', width: size, height: size }}>
      <CopyOutlined
        style={{
          fontSize: size,
          position: 'absolute',
          top: 0,
          left: 0,
          opacity: isCopied ? 0 : 1,
          transition: 'opacity 0.2s ease-in-out',
          cursor: 'pointer'
        }}
        onClick={handleCopy}
        className={className}
        id={id}
      />
      <CheckOutlined
        style={{
          fontSize: size,
          color: '#52c41a',
          position: 'absolute',
          top: 0,
          left: 0,
          opacity: isCopied ? 1 : 0,
          transition: 'opacity 0.2s ease-in-out'
        }}
        className={className}
        id={id}
      />
    </div>
  );

  return (
    <RoundContainer
      size={containerSize}
      onClick={!isCopied ? handleCopy : undefined}
      color='transparent'
      pointer={!isCopied}
    >
      {icon}
    </RoundContainer>
  );
};

export default CopyIcon;
